import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as API from '../../api/routes';
import {
  GET_PROFILE,
  ME_LOGOUT,
} from '../actions';

import { setCurrentUser } from '../../helpers/Utils';

import {
  getProfileSuccessed,
  getProfileFailed,
  logoutFailed,
} from './actions';

function* getProfile({ callback }) {
  try {
    const res = yield call(API.getProfile);
    yield put(getProfileSuccessed(res.result));
    yield call(callback?.(res.result));
  } catch (error) {
    yield put(getProfileFailed(error.message));
  }
}

function* logout({ callback }) {
  try {
    const res = yield call(API.logout);
    setCurrentUser(null)
    yield call(callback?.bind(res));
  } catch(error) {
    yield put(logoutFailed(error.message));
  }
}

export function* watchWorkers() {
  yield takeEvery(GET_PROFILE, getProfile);
  yield takeLatest(ME_LOGOUT, logout)
}

export default function* rootSaga() {
  yield all([
    fork(watchWorkers)
  ]);
}